import { BenefitType } from "../enums/BenefitType";
import { UploadedDocument } from "../domain/UploadedDocument";
import { MannerOfDeath } from "../enums/MannerOfDeath";

export type LifeFormValues = {
    dateOfDeath: string,
    mannerOfDeath: MannerOfDeath,
    documents: UploadedDocument[],
}

export const defaultLifeFormValues = {
    benefit: BenefitType.LIFE,
    life: true,
    dateOfDeath: '',
    mannerOfDeath: '',
    documents: [{
        document: '',
        documentContent: '',
        documentType: ''
    }],
}